import { isDemoPage } from '@src/utils/routes'
import * as qs from 'qs'
import { createSelector } from 'reselect'
import { RootState } from '../types'
import { setCookieFromQueryParams } from '@src/utils/queryParams'

export const getQueryParams = (state: RootState) => {
  const parsedQs = qs.parse(state.router.location.search, {
    ignoreQueryPrefix: true,
  })
  setCookieFromQueryParams(parsedQs)

  return parsedQs
}

export const getPathname = (state: RootState): string => state.router.location.pathname
export const getSearch = (state: RootState): string => state.router.location.search

export const isDemoSelector = createSelector([getPathname], isDemoPage)

export const getPathWithSearch = createSelector(
  [getPathname, getSearch],
  (pathname, search) => `${pathname}${search}`
)



// WEBPACK FOOTER //
// ./src/state/router/selectors.ts